export default "__VITE_ASSET__DBWGcO9$__"